module.exports = __webpack_public_path__ + "media/images/flags/1x1/ecu-cf7c465c2f07dff714cd24ae6e4d261f.svg";